// src/claims.ts
var EMPTY = { tenants: [], solutions: [], platform: [], apps: {} };
var PLATFORM_SUPERADMIN = "SUPERADMIN";
function decodeSegment(part) {
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - b64.length % 4) % 4);
  try {
    if (typeof globalThis.atob === "function") {
      const raw = globalThis.atob(padded);
      return decodeURIComponent(
        raw.split("").map((ch) => `%${`00${ch.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")
      );
    }
    return Buffer.from(padded, "base64").toString("utf8");
  } catch {
    return null;
  }
}
function readOrionClaims(token) {
  if (typeof token !== "string" || token === "") return EMPTY;
  const part = token.split(".")[1];
  if (part === void 0 || part === "") return EMPTY;
  const json = decodeSegment(part);
  if (json === null) return EMPTY;
  try {
    const payload = JSON.parse(json);
    const o = payload.orion;
    if (o === void 0 || o === null) return EMPTY;
    return {
      tenants: Array.isArray(o.tenants) ? o.tenants.map((t) => t ?? {}).filter((t) => typeof t.id === "string" && t.id !== "").map((t) => ({
        id: t.id,
        role: typeof t.role === "string" ? t.role : "viewer",
        ...typeof t.slug === "string" ? { slug: t.slug } : {},
        ...Array.isArray(t.modules) ? { modules: t.modules.filter((m) => typeof m === "string") } : {}
      })) : [],
      solutions: Array.isArray(o.solutions) ? o.solutions.filter((x) => typeof x === "string") : [],
      platform: Array.isArray(o.platform) ? o.platform.filter((x) => typeof x === "string") : [],
      apps: readApps(o.apps)
    };
  } catch {
    return EMPTY;
  }
}
function pickTenant(claims, preferred) {
  if (claims.tenants.length === 0) return null;
  if (typeof preferred === "string" && preferred !== "") {
    const hit = claims.tenants.find((t) => t.id === preferred);
    if (hit !== void 0) return hit;
  }
  return claims.tenants[0] ?? null;
}
function readApps(raw) {
  if (raw === null || typeof raw !== "object" || Array.isArray(raw)) return {};
  const out = {};
  for (const [key, value] of Object.entries(raw)) {
    if (value === null || typeof value !== "object") continue;
    const g = value;
    out[key] = {
      // `=== true` et non une conversion en booléen : la chaîne « false »
      // serait vraie, et c'est exactement ce qu'un jeton bricolé contiendrait.
      superadmin: g.superadmin === true,
      modules: Array.isArray(g.modules) ? g.modules.filter((m) => typeof m === "string") : []
    };
  }
  return out;
}
function isPlatformSuperadmin(claims) {
  return claims.platform.includes(PLATFORM_SUPERADMIN);
}
function canOpenModule(claims, applicationKey, moduleKey) {
  if (isPlatformSuperadmin(claims)) return true;
  const grant = claims.apps[applicationKey];
  if (grant === void 0) return false;
  if (grant.superadmin) return true;
  return grant.modules.includes(moduleKey);
}
function canOpenModuleInTenant(claims, tenantId, applicationKey, moduleKey) {
  if (isPlatformSuperadmin(claims)) return true;
  if (claims.apps[applicationKey]?.superadmin === true) return true;
  const t = tenantId === null ? void 0 : claims.tenants.find((x) => x.id === tenantId);
  if (t?.modules !== void 0) return t.modules.includes(moduleKey);
  return canOpenModule(claims, applicationKey, moduleKey);
}
var RANG_ROLE = { viewer: 0, analyst: 1, admin: 2, owner: 3 };
function hasRole(tenant, min) {
  if (tenant === null) return false;
  const rang = RANG_ROLE[tenant.role];
  const requis = RANG_ROLE[min];
  if (rang === void 0 || requis === void 0) return false;
  return rang >= requis;
}

export {
  PLATFORM_SUPERADMIN,
  readOrionClaims,
  pickTenant,
  isPlatformSuperadmin,
  canOpenModule,
  canOpenModuleInTenant,
  hasRole
};
